module.exports = __webpack_public_path__ + "img/kr-product-intl-card2-img3.06fc6fa.png";